import { TFunction } from 'react-i18next';

export interface CountryOption {
  value: string;
  label: string;
}

/**
 * Get localized country options for withdrawal forms
 */
export const getCountryOptions = (t: TFunction): CountryOption[] => [
  { value: 'US', label: t('studio.earnings.countries.unitedStates') },
  { value: 'OTHER', label: t('studio.earnings.countries.outsideUnitedStates') },
];
